import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import message from './modules/message'
import api from './modules/api'

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    message,
    api
  },
  getters: {
    java_api: status => status.api.java_api,
    php_api: status => status.api.php_api,
    token: state => state.user.token,
    name: state => state.user.name,
    mobile: state => state.user.mobile,
    menu: state => state.user.menu,
    unread_msg: state => state.message.unread_msg
  }
});
export default store



// WEBPACK FOOTER //
// ./src/store/index.js